import Container from "@material-ui/core/Container/Container";
import { Grid, Typography } from "@material-ui/core";
import { StatCard } from "./StatCard";
import { connect } from "react-redux";
import "./AchievementsPanel.css";
import { RootState } from "../../../state/configureStore";

type AchievementsPanelProps = ReturnType<typeof mapStateToProps>;
const AchievementsPanel = (props: AchievementsPanelProps) => {
  if (!props.profile) return null;
  const { totalTimeRead, wordsPerMin, totalWordsRead, uniqueWordsRead } = props.profile;
  return (
    <div className="Achievements">
      <Container style={{ maxWidth: "var(--max-page-width)" }}>
        <Grid container justify="flex-start" className="achievementsHeader">
          <Typography variant="h6">ACHIEVEMENTS</Typography>
        </Grid>
        <Grid item xs={11}></Grid>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flexGrow: 1, paddingRight: "20px" }}>
            <Grid container className="statsGrid" justify="space-evenly">
              <Grid item>
                <StatCard
                  label="Total Reading Time"
                  tooltipLabel="Did you know if you read for 15 minutes a day or more you’ll become a stronger reader?"
                  imgAlt="Total Reading Time"
                  statsValue={Number(totalTimeRead)}
                  formatType="time"
                />
              </Grid>
              <Grid item>
                <StatCard
                  label="Avg. Speed"
                  tooltipLabel="WPM is how many words you read per minute out loud!"
                  imgAlt="Avg. Speed"
                  statsValue={wordsPerMin}
                  formatType="whole"
                  postfix="WPM"
                />
              </Grid>
              <Grid item>
                <StatCard
                  label="Total Words"
                  tooltipLabel="This counts all the words you read! How many can you read?"
                  imgAlt="Total Words"
                  statsValue={totalWordsRead}
                  formatType="whole"
                />
              </Grid>
              <Grid item>
                <StatCard
                  label="Unique Words"
                  tooltipLabel="This tracks each new word you say! Most fluent, adult readers know about 40,000 different words!"
                  imgAlt="Unique Words"
                  statsValue={uniqueWordsRead}
                  formatType="whole"
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  profile: state.currentUserState.currentUser,
});

export default connect(mapStateToProps)(AchievementsPanel);
